import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';
import { FormControlTemplatesService } from 'src/app/templates/form-control-templates.service';

@Component({
  selector: 'fpx-selectable-dropdown',
  templateUrl: './fpx-selectable-dropdown.component.html',
  styleUrls: ['./fpx-selectable-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxSelectableDropdownComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxSelectableDropdownComponent extends BaseFpxControlComponent {
  @Input() disableOptionCentering: boolean = true;
  @Input() enableInfiniteScroll: boolean = false;
  @Output() scrollCallback = new EventEmitter();
  selectedData: any;
  template: TemplateRef<any>;

  constructor(
    controlContainer: ControlContainer, 
    changeDetectorRef: ChangeDetectorRef,
    private _fromControlTemplateService:FormControlTemplatesService
  ) {
    super(controlContainer, changeDetectorRef);
  }

  protected doPreInit(): void {}

  protected doPostInit(): void {}

  onSelectionChange($event, data) {
    if ($event.isUserInput) {
      this.selectedData = data;
    }
    this.detectChanges();
  }

  setInitialSelectedData(list: any) {
    let _selectData;
    if (this.formControl.value) {
      _selectData = list.find((option) => { return option.id === this.formControl.value });
      if(!_selectData?.id && this.formControl.hasValidator(Validators.required)) this.formControl.setErrors({required: true});
    } else {
      _selectData = null;
    }

    this.selectedData = _selectData;
  }

  getTemplate(ngTemplateName:string): TemplateRef<any> {
    let tmplt = this._fromControlTemplateService.getTemplate(ngTemplateName, 'dropdown');
    return tmplt;
  }
  onScroll() {
    console.log("Scrolled");
    this.scrollCallback.emit();
  }

}
